export default __webpack_public_path__ + "static/media/logo.9725bb16.svg";